import { render, staticRenderFns } from "./bodytalklogosvg.vue?vue&type=template&id=0196524a"
import script from "./bodytalklogosvg.vue?vue&type=script&lang=js"
export * from "./bodytalklogosvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports